export default "__VITE_PUBLIC_ASSET__5fab8f1b__"